module.exports = __webpack_public_path__ + "static/media/Night.c072feaf.svg";